import React from "react";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import {styleVars} from "../../app-style-vars";
import PtRadioButtons from "../core/pt-radio-buttons";
import {getTranslation} from "../../helpers/getTranslation";
import PtDateTimeRange from "../core/pt-date-time-picker/pt-date-time-range";
import PtText from "../core/pt-text/pt-text";


const tomorrow = new Date().setDate(new Date().getDate() + 1);
const yearAgo = new Date(tomorrow).setFullYear(new Date(tomorrow).getFullYear() - 1);

export default function PtTicketsTrackingFilter(props:any) {

  /** labels */
  const ticketStatusTitle = props.filtersOptions?.ticketStatus?.title || ' Ticket status';
  const ticketTypeTitle = props.filtersOptions?.ticketType?.title || 'Ticket type';
  /** data */
  const ticketStatusChoices = props.filtersOptions?.ticketStatus?.choices || [];
  const ticketTypeChoices = props.filtersOptions?.ticketType?.choices || [];
  const ticketDateRangeTitle = props.filtersOptions?.ticketDate?.title || 'Ticket date';
  const startDateLabel = props.filtersOptions?.ticketDate?.startDateLabel || 'From';
  const endDateLabel = props.filtersOptions?.ticketDate?.endDateLabel || 'To';
  const startDate = props.requestParams.dateFrom;
  const endDate = props.requestParams.dateTo;
  const minDate = props.filtersOptions?.ticketDate?.minDate || yearAgo;
  const maxDate = props.filtersOptions?.ticketDate?.maxDate;

  /** settings */
  const filtersContainerStyle = props.show ? styles.filtersContainerShown : null;

  /** pass through handlers */
  const ticketStatusFilterChangedHandler = props.ticketStatusFilterChangedHandler;
  const ticketTypeFilterChangedHandler = props.ticketTypeFilterChangedHandler;
  const startDateChangedHandler = props.startDateChangedHandler;
  const endDateChangedHandler = props.endDateChangedHandler;

  const applyFilters = () => {
    props.applyFiltersHandler();
  }

  return (
    <View style={[styles.filtersContainer, filtersContainerStyle]}>
      <View style={[styles.filtersWrapper]}>
        <View style={[styles.radioButtonsContainer]}>
          <PtRadioButtons
            title={ticketStatusTitle}
            buttons={ticketStatusChoices}
            requestParams={props.requestParams}
            initialValue = {props.requestParams.status}
            valueChangedHandler = {ticketStatusFilterChangedHandler}
          />
        </View>

        <View style={[styles.radioButtonsContainer]}>
          <PtRadioButtons
            title={ticketTypeTitle}
            buttons={ticketTypeChoices}
            requestParams={props.requestParams}
            initialValue = {props.requestParams.ticketType}
            valueChangedHandler = {ticketTypeFilterChangedHandler}
          />
        </View>

        <View style={[styles.datePickerContainer]}>
          <PtDateTimeRange
            title={ticketDateRangeTitle}
            dateFromLabel={startDateLabel}
            dateToLabel={endDateLabel}
            requestParams={props.requestParams}
            startDate={props.requestParams.dateFrom || startDate}
            endDate={props.requestParams.dateTo || endDate}
            minDate={minDate}
            maxDate={maxDate}
            startDateChangedHandler = {startDateChangedHandler}
            endDateChangedHandler = {endDateChangedHandler}
          />
        </View>
      </View>
      <View style={[styles.applyFiltersContainer]}>
        <TouchableOpacity onPress={() => applyFilters()}>
          <View style={[styles.applyFiltersButton]}>
            <PtText style={[styles.applyButtonText]}>{getTranslation('due.payments.apply.button.label')}</PtText>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  filtersContainer: {
    paddingVertical: styleVars.rem(.5),
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    display: 'none',
    zIndex: 2
  },
  filtersContainerShown: {
    display: 'flex',
  },
  filtersWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    zIndex: 2
  },
  radioButtonsContainer: {
    minWidth: 300
  },
  datePickerContainer: {
    minWidth: 300
  },
  applyFiltersContainer: {
    justifyContent: 'center',
    width: '100%',
    maxWidth: 300
  },
  applyFiltersButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: styleVars.boschDarkBlue,
    height: styleVars.rem(2.5),
    paddingHorizontal: styleVars.rem(1),
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 0,
  },
  applyButtonText: {
    color: styleVars.boschDarkBlue
  }
})